import { sortBy } from '@utils/arrays';
import { formatters, ValueInput } from '@utils/formattersV2';
import { chartColors } from '@utils/unifiedPlatformColorPalette';

const formatter = (value: ValueInput) =>
  formatters.currency(value, { full: true, decimals: 0 });

export type DonutChartOptionsProps = {
  titleText: string;
  data: {
    name: string;
    value: ValueInput;
  }[];
};

export const donutChartOptions = (
  props: DonutChartOptionsProps
): Highcharts.Options => ({
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false,
  },
  title: {
    verticalAlign: 'middle',
    text: props.titleText,
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
    },
  },
  tooltip: {
    pointFormatter() {
      return formatter(this.y);
    },
  },
  series: [
    {
      type: 'pie',
      size: '80%',
      innerSize: '60%',
      dataLabels: {
        useHTML: true,
        formatter() {
          return `${this.name}<br />${formatter(this.y)}`;
        },
        style: {
          fontWeight: 'normal',
          textAlign: 'center',
        },
      },
      data: props.data
        .toSorted(sortBy('value', 'desc'))
        .map((dataItem, index) => ({
          name: dataItem.name,
          y: dataItem.value ?? 0,
          color: chartColors[index % chartColors.length],
        })),
    },
  ],
});
